import React from "react";
const SvgComponent = ({ index }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={33} fill="none">
    <g filter="url(#a)">
      <ellipse cx={16} cy={29} fill="#000" fillOpacity={0.12} rx={4} ry={2} />
    </g>
    <mask
      id="b"
      width={32}
      height={28}
      x={0}
      y={1}
      fill="#000"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M0 1h32v28H0z" />
      <path
        fillRule="evenodd"
        d="M12.346 22H11C5.477 22 1 17.523 1 12S5.477 2 11 2h10.04C26.546 2.022 31 6.49 31 12c0 5.514-4.462 9.985-9.973 10h-1.373c-1.303 1.322-2.498 3.05-2.883 5.32-.064.381-.384.677-.771.677s-.707-.296-.771-.677c-.384-2.27-1.58-3.998-2.883-5.32Z"
        clipRule="evenodd"
      />
    </mask>
    <path
      fill="#000405"
      fillRule="evenodd"
      d="M12.346 22H11C5.477 22 1 17.523 1 12S5.477 2 11 2h10.04C26.546 2.022 31 6.49 31 12c0 5.514-4.462 9.985-9.973 10h-1.373c-1.303 1.322-2.498 3.05-2.883 5.32-.064.381-.384.677-.771.677s-.707-.296-.771-.677c-.384-2.27-1.58-3.998-2.883-5.32Z"
      clipRule="evenodd"
    />
    <path
      fill="#FAFEFF"
      fillOpacity={0.5}
      d="M11 22v1-1Zm1.346 0 .712-.702-.293-.298h-.42v1ZM11 2V1v1Zm10.04 0 .004-1h-.003v1Zm-.013 20v1h.003l-.003-1Zm-1.373 0v-1h-.418l-.294.298.712.702Zm-2.883 5.32.986.166-.986-.166Zm-1.542 0-.986.166.986-.166ZM11 23h1.346v-2H11v2ZM0 12c0 6.075 4.925 11 11 11v-2a9 9 0 0 1-9-9H0ZM11 1C4.925 1 0 5.925 0 12h2a9 9 0 0 1 9-9V1Zm10.04 0H11v2h10.04V1ZM32 12c0-6.06-4.9-10.976-10.956-11l-.008 2A9 9 0 0 1 30 12h2ZM21.03 23C27.091 22.984 32 18.065 32 12h-2a9 9 0 0 1-8.975 9l.005 2Zm-1.376 0h1.373v-2h-1.373v2Zm-.712-1.702c-1.392 1.413-2.727 3.318-3.157 5.855l1.972.334c.34-2.002 1.395-3.553 2.61-4.785l-1.425-1.404Zm-3.157 5.855a.167.167 0 0 1 .056-.098.242.242 0 0 1 .159-.058v2c.921 0 1.62-.695 1.757-1.51l-1.972-.334Zm.215-.156c.069 0 .125.028.16.058.031.029.049.063.055.098l-1.972.334c.138.815.836 1.51 1.757 1.51v-2Zm.215.156c-.43-2.537-1.765-4.442-3.157-5.855l-1.425 1.404c1.215 1.232 2.27 2.783 2.61 4.784l1.972-.333Z"
      mask="url(#b)"
    />
    <path
      fill="#F8E9E9"
      d="M19.02 16.583c-.28 0-.52-.1-.72-.3-.2-.2-.3-.44-.3-.72V14.03h1.02v1.532h6.126V14.03h1.02v1.532c0 .28-.1.52-.3.72-.2.2-.44.3-.72.3H19.02Zm3.063-2.041-2.552-2.552.715-.74 1.327 1.327v-4.16h1.02v4.16l1.328-1.327.714.74-2.552 2.552Z"
    />
    <text
      x="38%"
      y="47%"
      textAnchor="middle"
      fill="white"
      fontSize="13"
      fontWeight="500"
      fontFamily="Tajawal"
    >
      {index}
    </text>
    <defs>
      <filter
        id="a"
        width={12}
        height={8}
        x={10}
        y={25}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_2826_250880"
          stdDeviation={1}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgComponent;
